import { useMutation } from "@tanstack/react-query";

import { useAuthenticated } from "../auth/SessionProvider";
import { post, postFile } from "./client";
import { downloadBlob } from "./scores";
import type { AnswerSheetResponse } from "./types";

export type ExportKind = "scores" | "answers" | "attendance" | "paper" | "answer-sheets";

/** Downloads a server-generated file and hands it to the browser. */
export function useExport() {
  const { token } = useAuthenticated();
  return useMutation({
    mutationFn: async (input: { kind: ExportKind; body: Record<string, unknown>; fallbackName: string }) => {
      const { blob, filename } = await postFile(`/exports/${input.kind}`, input.body, token, input.fallbackName);
      downloadBlob(filename, blob);
      return filename;
    }
  });
}

export function useAnswerSheet() {
  const { token } = useAuthenticated();
  return useMutation({
    mutationFn: (username: string) => post<AnswerSheetResponse>("/answer-sheets/get", { username }, token)
  });
}
